export default __webpack_public_path__ + "static/media/investments31.884192e9.webp";